export default __webpack_public_path__ + "static/media/icon-youtube-link.7a9432d0.svg";